import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Strips tracking parameters (utm_*, ref, aff, fbclid, gclid, etc.)
 * and enforces lowercase, no-trailing-slash URLs to prevent
 * Google from indexing parameter/variant URLs as separate pages.
 */
const CanonicalEnforcer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // 1. Enforce lowercase URLs (except home)
    const lowered = pathname.toLowerCase();
    
    // 2. Remove trailing slash (except root "/")
    const cleaned = lowered.length > 1 ? lowered.replace(/\/+$/, "") : lowered;

    // 3. Strip tracking/marketing query parameters
    const params = new URLSearchParams(search);
    const trackingParams = [
      "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content",
      "ref", "aff", "fbclid", "gclid", "msclkid", "dclid", "twclid",
      "mc_cid", "mc_eid", "li_fat_id", "_ga", "_gl"
    ];
    let paramsChanged = false;
    trackingParams.forEach((p) => {
      if (params.has(p)) {
        params.delete(p);
        paramsChanged = true;
      }
    });

    const newSearch = params.toString() ? `?${params.toString()}` : "";

    // Only navigate if something changed
    if (cleaned !== pathname || paramsChanged) {
      navigate(`${cleaned}${newSearch}${hash}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default CanonicalEnforcer;
